import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export const MARKETING_ROUTES = {
  SALON_LANDING: '/saas/landing/salon',
} as const;

export interface ShowcaseService {
  id: string;
  name: string;
  price: number;
  durationMinutes: number;
  image: string | null;
}

export interface ShowcaseCategory {
  id: string;
  name: string;
  image: string | null;
  services: ShowcaseService[];
}

export interface Showcase {
  company: {
    id: string;
    name: string;
    businessType: string;
    phone: string | null;
    logo: string | null;
  };
  units: {
    id: string;
    name: string;
    city: string | null;
    address: string | null;
    phone: string | null;
  }[];
  categories: ShowcaseCategory[];
  professionals: { id: string; name: string }[];
}

/** Vitrine publica: e o unico endpoint da landing, e nao pede sessao. */
export function useShowcase() {
  return useQuery({
    queryKey: ['showcase'],
    queryFn: () => apiClient.get<Showcase>('/api/v1/public/showcase'),
    staleTime: 5 * 60 * 1000,
  });
}

export interface PublicPlan {
  id: string;
  name: string;
  description: string | null;
  monthlyPrice: number;
  calculatedMonthlyPrice: number | null;
  maxUsers: number | null;
  introPrice: number | null;
  introMonths: number;
  includedMessages: number | null;
  isActive: boolean;
  businessMultiplier: number;
  features: string[];
  businessFeatures: string[];
  ctaLabel: string | null;
  highlighted: boolean;
  order: number;
}

/** Os mesmos planos que cobram de verdade - o admin do SaaS configura em
 * Configurações > Planos, e a tabela de precos da landing le direto daqui. */
export function usePublicPlans() {
  return useQuery({
    queryKey: ['public-plans'],
    queryFn: () => apiClient.get<{ data: PublicPlan[] }>('/api/v1/public/plans'),
    staleTime: 5 * 60 * 1000,
  });
}
